import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';

@Injectable({
  providedIn: 'root'
})
export class StoreService {
  constructor(private apollo: Apollo) {}

  clearStore() {
    this.apollo.client.clearStore();
  }
}
